import { combineReducers } from '@reduxjs/toolkit';
import { configDetailsReducers } from '@repo/config-services';

import automationConfigReducer from './automationConfigSlice';
import automationListReducer from './automationList';
import reactFlowReducer from './reactFlowSlice';

export const AUTOMATIONS_REDUCER_PATH = 'automations';

export const automationsReducer = combineReducers({
  flowNodes: reactFlowReducer,
  automationConfig: automationConfigReducer,
  configDetails: configDetailsReducers,
  automationList: automationListReducer,
});

export interface RootState {
  automations: ReturnType<typeof automationsReducer>;
}
